var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Youtube_White",
    "data-name": "Youtube/White",
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.384,
    height: 8.772,
    viewBox: "0 0 12.384 8.772",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Youtube",
    d: "M6.192,8.772c-.032,0-3.231-.031-4.211-.126-.047-.009-.1-.016-.168-.023a1.82,1.82,0,0,1-1.2-.51A2.724,2.724,0,0,1,.124,6.876,19.183,19.183,0,0,1,0,4.857V3.911A19.2,19.2,0,0,1,.124,1.892,2.725,2.725,0,0,1,.616.654,1.7,1.7,0,0,1,1.778.134L1.857.126C3.57,0,6.163,0,6.189,0h.005c.026,0,2.619,0,4.333.126l.079.008a1.7,1.7,0,0,1,1.162.52,2.729,2.729,0,0,1,.492,1.238,19.189,19.189,0,0,1,.124,2.019v.946a19.2,19.2,0,0,1-.124,2.019,2.729,2.729,0,0,1-.492,1.238,1.7,1.7,0,0,1-1.161.52l-.08.008C8.813,8.767,6.218,8.772,6.192,8.772ZM4.913,2.5V6L8.259,4.258Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.97159eeeac261a68fd298d6e622b8f62.svg";
export { ForwardRef as ReactComponent };